"use client";

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

const SUBMENU_CLOSE_DELAY_MS = 200;

const NavMenuContext = createContext(null);

export function NavMenuProvider({ children }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const leaveTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (leaveTimerRef.current) clearTimeout(leaveTimerRef.current);
    };
  }, []);

  const notifyEnter = useCallback((index) => {
    if (leaveTimerRef.current) {
      clearTimeout(leaveTimerRef.current);
      leaveTimerRef.current = null;
    }
    setActiveIndex(index);
  }, []);

  const notifyLeave = useCallback(() => {
    leaveTimerRef.current = setTimeout(() => {
      setActiveIndex(null);
      leaveTimerRef.current = null;
    }, SUBMENU_CLOSE_DELAY_MS);
  }, []);

  const value = useMemo(
    () => ({
      activeIndex,
      notifyEnter,
      notifyLeave,
    }),
    [activeIndex, notifyEnter, notifyLeave]
  );

  return (
    <NavMenuContext.Provider value={value}>{children}</NavMenuContext.Provider>
  );
}

export function useNavMenu() {
  const ctx = useContext(NavMenuContext);
  if (!ctx) {
    throw new Error("useNavMenu doit être utilisé dans un NavMenuProvider");
  }
  return ctx;
}
